import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { GeneralCsvReportEntity } from "domain/entity/GeneralCsvReport/GeneralCsvReportEntity";
import { axiosGetData, axiosPostData } from "../axios/AxiosBasicImpl";
import reportAxiosInstance from "../axios/reportAxiosInstance";
import { GeneralCsvReportRepository } from "./GeneralCsvReportRepo";

export const GeneralCsvReportRepoImpl = (): GeneralCsvReportRepository => {


    const initGeneralCsvReportList = async (): Promise<string[]> => {
        const searchUrl = "/v1/initGeneralCsvReportList"
        return axiosGetData(reportAxiosInstance, `${searchUrl}`, []).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const exportReport = async (entity: GeneralCsvReportEntity): Promise<ResponseEntity> => {
        const exportUrl = "/v1/generalCsvExport"
        return await axiosPostData(reportAxiosInstance, `${exportUrl}`, entity);
    }

    const download = async (entity: GeneralCsvReportEntity): Promise<ResponseEntity> => {
        const downloadUrl = "/v1/generalCsvDownload"
        return await axiosPostData(reportAxiosInstance, `${downloadUrl}`, entity);
    }

    return {
        initGeneralCsvReportList: initGeneralCsvReportList,
        exportReport: exportReport,
        download: download,
    }
}
